"use client"

import React from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "./ui/button"

function PrivacyPolicy() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white overflow-hidden">
      <nav className="w-full z-50 bg-gray-900/90 backdrop-blur-md py-3 shadow-lg">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-2">
              <span className="text-2xl font-bold" onClick={() => navigate("/home")}>Rivals <span className="text-emerald-400">Sportsbook</span></span>
            </div>
            <div className="flex items-center space-x-3">
              <Button onClick={()=>{navigate("/signin")}} variant="outline" className="border-gray-700 hover:bg-gray-800 hover:text-white">Log In</Button>
              <Button onClick={()=>{navigate("/signup")}} className="bg-emerald-500 hover:bg-emerald-600 text-white">Sign Up</Button>
            </div>
          </div>
        </div>
      </nav>

      <div className="relative">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none -z-10"></div>
        <div className="absolute top-1/2 -left-40 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl pointer-events-none -z-10"></div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h1 className="text-4xl font-bold mb-3">Privacy Policy</h1>
              <p className="text-gray-300">Your privacy is important. Here’s how we protect it.</p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 shadow-xl space-y-8">
              <section>
                <h2 className="text-2xl font-semibold mb-3">1. Information We Collect</h2>
                <p className="text-gray-300">We collect account information you provide (such as name, email, and DOB), usage data, device information, and limited payment metadata necessary to process deposits and withdrawals. We do not store full card or banking details on our servers.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">2. How We Use Your Information</h2>
                <ul className="list-disc pl-5 text-gray-300 space-y-2">
                  <li>Provide and improve the Rivals Sportsbook experience</li>
                  <li>Verify identity, age, and maintain account security</li>
                  <li>Process transactions and provide customer support</li>
                  <li>Comply with legal and regulatory obligations</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">3. Sharing of Information</h2>
                <p className="text-gray-300">We share data with service providers only as needed to operate the platform (e.g., payments, analytics, cloud hosting). We do not sell your personal information.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">4. Data Security</h2>
                <p className="text-gray-300">We use industry-standard security controls to protect your data, including encryption in transit, least-privilege access, and continuous monitoring.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">5. Your Rights</h2>
                <p className="text-gray-300">You may access, update, or delete your account information. For data requests, contact us at <span className="text-emerald-400">rivalssportbook@gmail.com</span>.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">6. Children’s Privacy</h2>
                <p className="text-gray-300">Rivals Sportsbook is for users 18+ only. We do not knowingly collect data from minors.</p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-3">7. Changes to this Policy</h2>
                <p className="text-gray-300">We may update this policy from time to time. Material changes will be posted on this page with an updated date.</p>
              </section>

              <div className="pt-4">
                <Button onClick={()=>navigate("/")} className="bg-emerald-500 hover:bg-emerald-600 text-white">Back to App</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy


